import "./Text.scss"

import React, { forwardRef } from "react"
import cx from "classnames"

export type TextType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "pSmallest"

interface ITextProps {
    type?: TextType
    title?: string
    className?: string
    inline?: boolean
    bold?: boolean
    role?: React.HTMLAttributes<HTMLDivElement>["role"]
    preLine?: boolean
    preWrap?: boolean
}

const Text = forwardRef<HTMLDivElement | HTMLHeadingElement, React.PropsWithChildren<ITextProps>>(({
    type = "p",
    title,
    className,
    inline,
    bold,
    role,
    preLine,
    preWrap,
    children,
    ...others
}, ref) => {
    const props = {
        className: cx([
            "text",
            `text--type-${type}`,
            className,
            {
                "text--inline": inline,
                "font-bold": bold,
                "white-space-pre-line": preLine,
                "white-space-pre-wrap": preWrap,
            }
        ]),
        role,
        title,
        ...others
    }

    if (!children) return null

    switch(type) {
        case "h1":
            return <h1 {...props}>{children}</h1>
        case "h2":
            return <h2 {...props}>{children}</h2>
        case "h3":
            return <h3 {...props}>{children}</h3>
        case "h4":
            return <h4 {...props}>{children}</h4>
        case "h5":
            return <h5 {...props}>{children}</h5>
        case "h6":
            return <h6 {...props}>{children}</h6>
        default:
            return <div {...props}>{children}</div>
    }
})

export default Text
